import type { Placement } from '@popperjs/core';
import { Button } from '@timelyapp/react';
import Popover from 'components/popovers/Popover';
import config from 'config';
import React, { Component } from 'react';
import type { BaseEmoji, EmojiData } from './EmojiPicker';
import Picker from './EmojiPicker';
import styles from './EmojiPickerDropdown.module.scss';

interface Props {
  position?: Placement | null;
  onChange: (a: { imageUrl: string }) => unknown;
  value?: string | null;
  buttonClassName?: string;
  disabled?: boolean;
}

interface State {
  isOpen: boolean;
}

export default class EmojiPickerDropdown extends Component<Props, State> {
  state = {
    isOpen: false,
  };

  popover = React.createRef<Popover>();

  handleOnOpen = () => this.setState({ isOpen: true });

  handleOnClose = () => this.setState({ isOpen: false });

  handleOnClick = (emoji: EmojiData) => {
    this.handleOnClose();
    this.props.onChange({
      ...emoji,
      imageUrl: `${config.emojiCdnPath}/${(emoji as BaseEmoji).unified}.png`,
    });
  };

  render() {
    return (
      <div className={styles.container}>
        <Popover
          fixed
          onOpen={this.handleOnOpen}
          onClose={this.handleOnClose}
          isOpen={this.state.isOpen}
          zIndex={config.zIndex.mainNav + 1}
          ref={this.popover}
          enableKeyTrap
          position={this.props.position || 'bottom'}
          target={
            <Button
              priority="low"
              className={this.props.buttonClassName}
              disabled={this.props.disabled}
            >
              {this.props.value ? <img src={this.props.value} alt="emoji" width={16} /> : null}
            </Button>
          }
        >
          <Picker set="twitter" onClick={this.handleOnClick} title="Select emoji" emoji=":label:" />
        </Popover>
      </div>
    );
  }
}
